import React, { } from 'react';
import { useSelector } from 'react-redux'

import { selectCursorPositionInMap } from '../app/interface.js'
import { selectMetricSystem, selectReferenceUnit } from '../app/inspection.js'

import './CursorPosition.css'


function CursorPosition(props) {
  const cursorPositionInMap = props.cursorPositionInMap;
  const metricSystem = useSelector(selectMetricSystem)

  // Loading pending
  if (cursorPositionInMap == null){
    return <></>;
  }

  // Compute position in display-units
  const pos = metricSystem(cursorPositionInMap)

  // Check if pos.x and pos.y are defined before calling toFixed
  if (pos.x == null || pos.y == null) {
    return <></>;
  }

  return <div className="cursor-position">
    <div>
      X: {pos.x.toFixed(3)} {pos.xUnit || ''}
    </div>
    <div>
      Y: {pos.y.toFixed(3)} {pos.yUnit || ''}
    </div>
  </div>
}

export default CursorPosition;